import { render } from "./TuitionSetting.vue?vue&type=template&id=47683dcc&scoped=true"
import script from "./TuitionSetting.vue?vue&type=script&lang=js"
export * from "./TuitionSetting.vue?vue&type=script&lang=js"

import "./TuitionSetting.vue?vue&type=style&index=0&id=47683dcc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47683dcc"]])

export default __exports__